import React, { useEffect, useRef, useState } from "react";
import Header from "../../../../layout/header/Header";
import ActiveLink from "../../../../layout/active-link/ActiveLink";
import "./CreateQuestion.scss";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  getAssessmentById,
  postAssessment,
  deleteAssessmentQuestion,
  deleteAssessmentAnsweer,
  putAssessmentQuestion,
  putAssessmentOptions,
} from "../../../../../api/services/assessment-apis";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  ansObj,
  assessmentDetails,
  getCheckBoxData,
  getNewAnsData,
  getNewQuesData,
  getSelectedQuesData,
  setCheckBoxData,
  setNewAnsData,
  setNewQuesData,
  setSelectedQuesData,
} from "../../../../../shared/share-data";
import { useLocation, useNavigate } from "react-router-dom";

const CreateQuestion = () => {
  const [existQuestionsList, setQuestionsList] = useState<any>([]);
  const [newQuestionsList, setNewQuestionsList] = useState<any>([]);
  const [newAnswersList, setNewAnswersList] = useState<any>([]);
  const [showQuestion, setShowQuestion] = useState(false);
  const [isOpen, setPopupClose] = useState(false);
  const [isConfirmOpen, setConfirmPopup] = useState(false);
  const [setName, setSetName] = useState("");
  const [disableAddBtn, setDisableAddBtn] = useState(true);
  const [copiedFromExisting, setCopiedFromExisting] = useState(false);
  const [setNameInfo, setSetNameInfo] = useState<any>();
  const location = useLocation();
  const navigate = useNavigate();
  const setNameAndDomain = location.state?.NewSetDetails;
  console.log(assessmentDetails, setNameAndDomain);

  const [addNewAInputsArr, setAddNewAInputsArr] = useState<any[]>([]);
  const [addNewQInputsArr, setAddNewQInputsArr] = useState<any[]>([
    {
      quesId: 0,
      type: "text",
      value: "",
      options: [
        {
          optionId: 0,
          type: "text",
          value: "",
          score: null,
        },
      ],
    },
  ]);

  //manjuanth added state for sections
  interface Option {
    optionId: number;
    answer: string;
    suggestion: string;
    score: number | null;
  }

  interface Question {
    quesId: number;
    quesDscr: string;
    createdOn: string;
    updatedOn: string;
    options: Option[];
  }

  interface Section {
    sectionId: number;
    sectionName: string;
    questions: Question[];
  }
  const [sections, setSections] = useState<any[]>([
  ]);
  const [isSectionPopupOpen, setIsSectionPopupOpen] = useState(false);
  const [newSectionName, setNewSectionName] = useState("");
  const sectionInputRef = useRef<HTMLInputElement>(null); // Create a ref for the input field
  const questionInputRef = useRef<HTMLInputElement>(null); // Ref for the question input field
  const answerInputRef = useRef<HTMLInputElement>(null); // Ref for the answer input field

  const handleAddSectionClick = () => {
    setIsSectionPopupOpen(true);
    setTimeout(() => {
      sectionInputRef.current?.focus(); // Focus the input field when the popup opens
    }, 0);
  };

  const addQuestionToSection = (sectionId: number) => {
    const newQuestion = {
      quesId: Date.now(),
      quesDscr: "",
      options: [],
    };

    const updatedSections = sections.map((section) => {
      if (section.sectionId === sectionId) {
        return {
          ...section,
          questions: [...section.questions, newQuestion],
        };
      }
      return section;
    });

    setSections(updatedSections);

    setTimeout(() => {
    questionInputRef.current?.focus();
  }, 0);
  };

  const handleClick = () => {
    setDisableAddBtn(true);
    setShowQuestion(true);
  };

  const confirmPopup = (eve: string) => () => {
    if (
      newQuestionsList &&
      newQuestionsList.length > 0 &&
      !copiedFromExisting
    ) {
      confirmPopupActions(eve);
    }
  };

  const confirmPopupActions = (val: string) => {
    if (val == "Yes") {
      saveAnswers();
    }
    if (newAnswersList && newAnswersList.length > 0 && !copiedFromExisting) {
      setAddNewAInputsArr([]);
    }
    setConfirmPopup(false);
    setPopupClose(false);
  };

  const openPopUp = (item: any, idx: number, from: string) => {
    // console.log(item);
    setSelectedQuesData(item);
    if (from == "exist") {
      setNewAnswersList(item?.options);
      if (
        (item.options.find((opt: any) => opt.optionId != 0) &&
          !addNewAInputsArr.length) ||
        !newAnswersList.length
      ) {
        setAddNewAInputsArr([
          {
            optionId: 0,
            type: "text",
            value: "",
            score: null,
          },
        ]);
      }
    }
    if (from == "new") {
      setNewAnswersList([]);
      setAddNewAInputsArr(item?.options);
    }

    setPopupClose(true);
  };

  const onPopupClose = () => {
    if (
      newQuestionsList &&
      newQuestionsList.length > 0 &&
      !copiedFromExisting
    ) {
      setConfirmPopup(true);
    }
    setPopupClose(false);
  };

  const questionInputChange = (eve: any, idx: number) => {
    addNewQInputsArr[idx]["quesDscr"] = eve.target.value;
    setAddNewQInputsArr([...addNewQInputsArr]);
  };

  const optionsInputChange = (eve: any, aindx: number, from: string) => {
    // Check if the change is for 'answer' or 'suggestion'
    if (from === "ans") {
      // Update only the 'answer' field
      addNewAInputsArr[aindx]["answer"] = eve.target.value;
    } else if (from === "sgs") {
      // Update only the 'suggestion' field
      addNewAInputsArr[aindx]["suggestion"] = eve.target.value;
    } else if (from==="score")
    {
      const raw=eve.target.value;
      if(raw.trim()==="")
      {
        addNewAInputsArr[aindx]
        ["score"]=null;
      }
      else {
        const n=Number(raw);
        addNewAInputsArr[aindx]
        ["score"]=Number.isNaN(n)?null:Math.max(0,Math.floor(n));
      }
    }

    setAddNewAInputsArr([...addNewAInputsArr]);

    addNewQInputsArr.forEach((val) => {
      if (getSelectedQuesData().quesId === val.quesId) {
        val.options = [...addNewAInputsArr];
      }
    });

    setAddNewQInputsArr([...addNewQInputsArr]);
    console.log(addNewAInputsArr);
  };

  const addNewQuestion = () => {
    let ansListVals: any = [];
    let sgsListVals: any = [];
    addNewAInputsArr.forEach((val) => {
      ansListVals.push(val?.answer);
      sgsListVals.push(val?.suggestion);
      sgsListVals.push(val?.score)
    });
    console.log(ansListVals, sgsListVals, addNewAInputsArr);
    if (
      addNewAInputsArr.length == 0 ||
      ansListVals.includes(undefined) ||
      sgsListVals.includes(undefined)
    ) {
      toast.warning("Please add question & options/suggestions!");
    } else {
      checkValidations(addNewQInputsArr, "ques");
    }
  };

  const handleDeteteQues = (val: any, index: number, from: string) => {
    if (from == "exist" && val.quesId) {
      deleteAssessmentQuestion(val.quesId)
        .then((data) => {
          console.log(data);
          toast.success(data.data.message);
        })
        .catch((error) => {
          // handle error
          toast.error(error);
          console.log(error);
        });
    } else {
      addNewQInputsArr.splice(index, 1);
      setAddNewQInputsArr([...addNewQInputsArr]);
    }
  };

  const addNewAnswer = () => {
    checkValidations(getSelectedQuesData().options, "ans");
  };

  const handleDeteteAns = (val: any, index: number, from: string) => {
    if (from == "exist" && val.optionId) {
      deleteAssessmentAnsweer(val.optionId)
        .then((data) => {
          console.log(data);
          toast.success(data.data.message);
        })
        .catch((error) => {
          // handle error
          toast.error(error);
          console.log(error);
        });
    } else {
      addNewAInputsArr.splice(index, 1);
      setAddNewAInputsArr([...addNewAInputsArr]);
      addNewQInputsArr.forEach((lst) => {
        if (getSelectedQuesData().quesId == lst.quesId) {
          lst.options = [...addNewAInputsArr];
        }
      });
      setAddNewQInputsArr([...addNewQInputsArr]);
    }
  };

  const removeSection = (sectionId: number) => {
  const updatedSections = sections.filter(
    (section) => section.sectionId !== sectionId
  );
  setSections(updatedSections);
};

const editSectionName = (sectionId: number, newName: string) => {
  const updatedSections = sections.map((section) => {
    if (section.sectionId === sectionId) {
      return { ...section, sectionName: newName };
    }
    return section;
  });
  setSections(updatedSections);
};

  const saveAnswers = () => {
    const payload = {
      setID: setNameInfo?.setID ?? 0,
      setName: setNameAndDomain.setName,
      domain: setNameAndDomain.domain,
      createdBy: "LTIM",
      status: "Pending",
      createdDate: new Date(),
      updatedBy: "LTIM",
      updatedOn: new Date(),
      questionList: [
        {
          quesId: getSelectedQuesData().quesId,
          quesDscr: getSelectedQuesData().quesDscr,
          options: Array.from(new Set(addNewAInputsArr)).map((val) => {
            return {
              optionId: val.optionId,
              answer: val.answer,
              suggestion: val.suggestion,
              score: val.score ?? null,
            };
          }),
          createdOn: new Date(),
          updatedOn: new Date(),
        },
      ],
    };
    putAssessmentOptions(payload)
      .then((data) => {
        console.log(data);
        toast.success(data.data.message);
      })
      .catch((error) => {
        // handle error
        toast.error(error);
        console.log(error);
      });
  };

  const checkValidations = (array: any, from: string) => {
    let havingAllFieldVals: boolean = false;
    let isSameQuestion: boolean = false;
    const inputs: any = [];
    let isDuplicateQues: boolean = false;
    let questionInput: any = "";
    let isDuplicateAns: boolean = false;
    let isDuplicateSgs: boolean = false;
    let answerInput: any = "";
    let suggestionInput: any = "";
    let idx: number = 0;
    let existingQuesLst: any = [];
    array = Array.from(new Set(array));
    array &&
      array.length &&
      array.forEach((val: any, index: number) => {
        idx = index;
        havingAllFieldVals = true;
        if (from == "ques") {
          const questionId = `question${index}`;
          questionInput = document.getElementById(
            questionId
          ) as HTMLInputElement;
          if (questionInput) {
            inputs.push({ question: questionInput?.value });
          }
          const valueArr = inputs.map((item: any) => item.question);
          isDuplicateQues = valueArr.some(
            (item: any, idx: number) => valueArr.indexOf(item) != idx
          );
          setNewQuesData({
            quesId: 0,
            quesDscr: questionInput?.value,
            options: val.options,
            createdOn: new Date(),
            updatedOn: new Date(),
          });
        } else if ((from = "ans")) {
          answerInput = document.getElementById(
            "answer" + index
          ) as HTMLInputElement;
          suggestionInput = document.getElementById(
            "suggestion" + index
          ) as HTMLInputElement;
          if (answerInput || suggestionInput) {
            inputs.push({
              optionId: index,
              answer: answerInput?.value,
              suggestion: suggestionInput?.value,
              score: null,
            });
          }
          const valueAnsArr = inputs.map((item: any) => item.answer);
          const valueSgsArr = inputs.map((item: any) => item.suggestion);
          isDuplicateAns = valueAnsArr.some(
            (item: any, idx: number) => valueAnsArr.indexOf(item) != idx
          );
          isDuplicateSgs = valueSgsArr.some(
            (item: any, idx: number) => valueSgsArr.indexOf(item) != idx
          );
          setNewAnsData([...inputs]);
        }
        if (
          array.length > 1 &&
          ((from == "ques" && isDuplicateQues) ||
            (from == "ans" && (isDuplicateAns || isDuplicateSgs)))
        ) {
          isSameQuestion = true;
        }
        if (
          (from == "ques" && inputs.find((item: any) => !item.question)) ||
          (from == "ans" &&
            (inputs.find((item: any) => !item.answer) ||
              inputs.find((item: any) => !item.suggestion)))
        ) {
          havingAllFieldVals = false;
        }
        if (
          getSelectedQuesData() &&
          newQuestionsList.length &&
          newQuestionsList[index]
        ) {
          existingQuesLst.push(
            getSelectedQuesData().quesId == newQuestionsList[index].quesId
          );
        }
      });
    if (isSameQuestion) {
      from == "ques"
        ? toast.warning("Given question alraedy there in list.")
        : toast.warning("Given answer/suggestion alraedy there in list.");
    }
    if (havingAllFieldVals) {
      if (from == "ques") {
        addNewQInputsArr.push({
          quesId: idx + 1,
          type: "text",
          value: "",
          options: [
            {
              optionId: 0,
              type: "text",
              value: "",
              score: null,
            
            },
          ],
        });
        setAddNewQInputsArr([...addNewQInputsArr]);
      } else {
        if (existingQuesLst.includes(true)) {
          newQuestionsList.forEach((einputs: any) => {
            if (getSelectedQuesData().quesId == einputs.quesId) {
              einputs.options.push(addInput(idx)[0]);
            }
          });
          setNewQuestionsList([...newQuestionsList]);
        } else {
          addNewQInputsArr.forEach((ninputs: any) => {
            if (getSelectedQuesData().quesId == ninputs.quesId) {
              ninputs.options = [...ninputs.options, addInput(idx)[0]];
            }
          });
          setAddNewQInputsArr([...addNewQInputsArr]);
        }
      }
    } else {
      toast.warning("Please enter values in all inputs.");
    }
  };

  const addInput = (idx: number) => {
    addNewAInputsArr.push({
      optionId: idx + 1,
      type: "text",
      value: "",
      score: null,
    });
    console.log(addNewAInputsArr);
    setAddNewAInputsArr([...addNewAInputsArr]);
    return addNewAInputsArr;
  };

  const onAddQuestionPopupClose = () => {
    setShowQuestion(false);
    setSearchedSetQuestions(false);
  };

  useEffect(() => {
    getAssessmentById(setNameAndDomain.setName)
      .then((data: any) => {
        console.log(data);
        setSetNameInfo(data.data);
        setNewQuestionsList(data.data.questionList);
      })
      .catch((error) => {
        // handle error
        toast.error(error);
        console.log(error);
      });
  }, []);

  const [searchedSetQuestions, setSearchedSetQuestions] = useState(false);
  const onSearchName = () => {
    const input = document.getElementById("searchinput") as HTMLInputElement;
    if (input.value) {
      getAssessmentById(setName)
        .then((data: any) => {
          console.log(data.data.questionList);
          setQuestionsList(data.data.questionList);
        })
        .catch((error) => {
          // handle error
          toast.error(error);
          console.log(error);
        });
      setSearchedSetQuestions(true);
    } else {
      toast.warning("Please provide set name!");
    }
  };

  const checkBoxClick = (selected: any) => (eve: any) => {
    if (eve.target.checked) {
      setCheckBoxData(selected);
      setDisableAddBtn(false);
    } else {
      const index = getCheckBoxData().findIndex(
        (val: any) => val.id == selected.id
      );
      getCheckBoxData().splice(index, 1);
    }

    if (!getCheckBoxData().length) {
      setDisableAddBtn(true);
    }
  };

  const addExistingSetQuestions = () => {
    getCheckBoxData() &&
      setNewQuestionsList(newQuestionsList.concat(getCheckBoxData()));
    setShowQuestion(false);
    setCheckBoxData(null);
    setCopiedFromExisting(true);
  };

  const handleSubmit = () => {
    const payload = {
      setID: setNameInfo?.setID ?? 0,
      setName: setNameAndDomain.setName,
      domain: setNameAndDomain.domain,
      createdBy: "LTIM",
      status: "Pending",
      createdDate: new Date().toISOString(),
      updatedBy: "LTIM",
      updatedOn: new Date().toISOString(),
      sectionList: sections.map((section) => ({
        sectionId: section.sectionId,
        sectionName: section.sectionName,
        questionList: section.questions.map((question: Question) => ({
          quesId: question.quesId,
          quesDscr: question.quesDscr,
          createdOn: new Date().toISOString(),
          updatedOn: new Date().toISOString(),
          options: question.options.map((option) => ({
            optionId: option.optionId,
            answer: option.answer,
            suggestion: option.suggestion,
            score: option.score ??null,
          })),
        })),
      })),
    };

    console.log("Payload to be sent:", payload);

    postAssessment(payload)
      .then((response) => {
        console.log("Response:", response);
        toast.success("Payload submitted successfully!");
        navigate('/assessment'); // Navigate to assessment page on success
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Failed to submit payload.");
      });
  };

  return (
    <div className="container">
      <Header />
      <div className="app-pageSize">
        <ActiveLink targetLink="Questions" />
      </div>
      <div className="wrapper">
        <div
          style={{
            background: "#2F3A74",
            lineHeight: "30px",
            padding: "10px",
          }}
        >
          <p
            style={{
              color: "#FFFFFF",
              fontSize: "18px",
              marginBottom: 0,
            }}
          >
            Domain specified Questionnaire panel | {setNameAndDomain.domain}
          </p>
        </div>
        <div className="row" style={{ color: "#2F3A74" }}>
          <p
            className="col-sm-9"
            style={{ fontSize: "18px", fontWeight: "600" }}
          >
            Create New set of questions
          </p>
          {/* add questions from sets */}
          {showQuestion && (
            <div className="popup_container">
              <div className="popup">
                <div className="add-question-popup-content">
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div className="grid-container">
                      <span style={{ color: "#F0F0F0" }}>Set Name:</span>
                      <span className="search-section">
                        <input
                          type="text"
                          id="searchinput"
                          placeholder="LogicLink"
                          className="inputbox form-control"
                          onChange={(e) => setSetName(e.target.value)}
                        />
                        <button
                          className="search-button"
                          onClick={onSearchName}
                        >
                          Search
                        </button>
                      </span>
                      <button
                        className="close-button"
                        onClick={onAddQuestionPopupClose}
                      >
                        Close
                      </button>
                    </div>
                    {searchedSetQuestions && (
                      <div className="addTable">
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th>Questions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {existQuestionsList.map(
                              (row: any, index: number) => (
                                <tr>
                                  <td>
                                    <input
                                      type="checkbox"
                                      onChange={checkBoxClick(row)}
                                    />
                                  </td>
                                  <td>{row.quesDscr}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}
                    <div>
                      <button
                        className="add-question-button"
                        onClick={addExistingSetQuestions}
                        disabled={disableAddBtn}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* button to add questions from sets */}
          {!showQuestion && (
            <button
              className="float-end col-sm-3"
              style={{
                width: "210px",
                borderRadius: "15px",
                background: "#BD7F02",
                color: "#FFFFFF",
                padding: "5px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={handleClick}
            >
              Click here to Add Questions from another Set +
            </button>
          )}
        </div>
        {/* popup component */}
        {isOpen && (
          <div className="popup_container">
            <div className="popup">
              <div className="popup-content">
                {/* dropdown */}
                <>
                  <div className="table-containers">
                    <div className="table-wrapper">
                      <table className="custom-tables">
                        <thead className="header">
                          <th>Answers</th>
                          <th>Suggestion</th>
                        </thead>
                        <tbody>
                          {(newAnswersList || []).map(
                            (row: any, index: number) =>
                              row &&
                              row.answer &&
                              row.suggestion && (
                                <tr key={row.answer}>
                                  <td> {row.answer} </td>
                                  <td> {row.suggestion} </td>
                                  <td>
                                    <span
                                      style={{
                                        marginLeft: "33%",
                                        marginTop: "-2%",
                                      }}
                                      onClick={() =>
                                        handleDeteteAns(row, index, "exist")
                                      }
                                    >
                                      <img
                                        slot="end"
                                        className="crossImg"
                                        src={require("../../../../../images/cross.png")}
                                        alt=""
                                      />
                                    </span>
                                  </td>
                                </tr>
                              )
                          )}
                        </tbody>
                      </table>
                      <div>
                        <br />
                        {addNewAInputsArr.map((item: any, idx: number) => (
                          <div className="dropdownitems1">
                            <input
                              id={`answer${idx}`}
                              name={`answer${idx}`}
                              type={item.type}
                              value={item.answer}
                              onChange={(e) =>
                                optionsInputChange(e, idx, "ans")
                              }
                              className="answer-field form-control"
                              placeholder="Value"
                            />
                            <input
                              id={`suggestion${idx}`}
                              name={`suggestion${idx}`}
                              type={item.type}
                              value={item.suggestion}
                              onChange={(e) =>
                                optionsInputChange(e, idx, "sgs")
                              }
                              className="suggestion-field form-control"
                              placeholder="Enter text here"
                            />

                            <input
                              id={`score${idx}`}
                              name={`score${idx}`}
                              type="number"
                              className="score-field form-control score-field"
                              value={item.score===null||item.score===undefined?"":item.score}
                              min={0}
                              step={1}
                              placeholder="Score"
                              onKeyDown={(e)=>{
                                const invalidKeys = ["e", "E", "+", "-", "."];
                                if(invalidKeys.includes(e.key))
                                  e.preventDefault();
                              }}
                              onChange={(e)=>
                                optionsInputChange(e,idx,"score")
                              }
                            />

                            {addNewAInputsArr.length > 1 && (
                              <span
                                className="cross-button"
                                onClick={() =>
                                  handleDeteteAns(item, idx, "new")
                                }
                              >
                                <img
                                  className="crossImg"
                                  src={require("../../../../../images/cross.png")}
                                  alt="Remove"
                                />
                              </span>
                            )}
                          </div>
                        ))}
                      </div>
                      <br />
                      <br />
                      <span className="addbutton">
                        <button className="add-close" onClick={addNewAnswer}>
                          Add+
                        </button>
                      </span>
                      <span className="closebutton">
                        <button className="add-close" onClick={onPopupClose}>
                          Close
                        </button>
                      </span>
                      {newAnswersList.length > 0 && !copiedFromExisting && (
                        <span className="addbutton">
                          <button className="save" onClick={saveAnswers}>
                            Save
                          </button>
                        </span>
                      )}
                      <br />
                      <br />
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
        )}
        {/* table */}
        <div className="table-containers">
          <div className="table-wrapper">
            <table className="custom-tables">
              <thead className="table-heading">
                <th>SRL No</th>
                <th>Question</th>
                <th>Explore and Edit the options</th>
                <th>Delete</th>
              </thead>
              <tbody>
                {newQuestionsList.map((row: any, index: number) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{row.quesDscr}</td>
                    <td style={{ justifyContent: "center" }}>
                      <button
                        className="click-button"
                        onClick={() => openPopUp(row, index, "exist")}
                      >
                        Click Here
                      </button>
                    </td>
                    <td>
                      <img
                        className="delete-Img ms-3"
                        src={require("../../../../../images/delete.png")}
                        alt=""
                        onClick={() => handleDeteteQues(row, index, "exist")}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* {addNewQInputsArr.map((item: any, i: number) => (
              <div className="row mt-2 mb-3 ms-4">
                <div className="col-sm-9">
                  <input
                    id={`question${i}`}
                    name={`question${i}`}
                    type={item.type}
                    className="form-control textfield"
                    value={item.quesDscr}
                    onChange={(e) => questionInputChange(e, i)}
                    placeholder="Enter Your Question Here"
                  />
                </div>
                <div className="col-sm-2">
                  <button
                    className="add-suggestions"
                    onClick={() => openPopUp(item, i, "new")}
                  >
                    Add Suggestions
                  </button>
                </div>
                <div className="col-sm-1">
                  {addNewQInputsArr.length > 1 && (
                    <img
                      className="delete-Img"
                      src={require("../../../../../images/delete.png")}
                      alt=""
                      onClick={() => handleDeteteQues(item, i, "new")}
                    />
                  )}
                </div>
              </div>
            ))} */}
            <div className="box1" style={{ justifyContent: "center" }}>
              <button className="add-section-btn" onClick={handleAddSectionClick}>
                Add Section +
              </button>
              {/* <button className="Savebox">Save Changes</button> */}
            </div>
          </div>
        </div>
        {/* Add Section Button at the top only when there are no sections */}
        {sections.length === 0 && (
          <div className="add-section-container" style={{ marginBottom: "20px" }}>
            <button
              className="add-section-btn"
              onClick={() => setIsSectionPopupOpen(true)}
            >
              Add Section +
            </button>
          </div>
        )}

        {/* Render sections and questions */}
        <div className="sections">
          {sections.map((section) => (
            <div key={section.sectionId} className="section-container">
              <div className="section-header">
                <h4 className="section-title">{section.sectionName}</h4>
                <button
                  className="add-question-btn"
                  onClick={() => addQuestionToSection(section.sectionId)}
                >
                  Add Question +
                </button>
              </div>
              <div className="questions">
                {section.questions.map((question: Question, index: number) => (
                  <div key={question.quesId} className="question-container">
                    <input
                      type="text"
                      className="question-input"
                      style={{marginBottom: "12px"}}
                      value={question.quesDscr}
                      onChange={(e) => {
                        const updatedSections = sections.map((sec: Section) => {
                          if (sec.sectionId === section.sectionId) {
                            return {
                              ...sec,
                              questions: sec.questions.map((q: Question) =>
                                q.quesId === question.quesId
                                  ? { ...q, quesDscr: e.target.value }
                                  : q
                              ),
                            };
                          }
                          return sec;
                        });
                        setSections(updatedSections);
                      }}
                      placeholder="Enter your question here"
                      ref={index === section.questions.length - 1 ? questionInputRef : null} // Attach ref to the last added question

                    />

                    {/* Options and Suggestions */}
                    <div className="options">
                      {(question.options || []).map((option, idx) => (
                        <div key={option.optionId} className="option-container">
                          <input
                            type="text"
                            className="option-input"
                            value={option.answer}
                            onChange={(e) => {
                              const updatedSections = sections.map((sec: Section) => {
                                if (sec.sectionId === section.sectionId) {
                                  return {
                                    ...sec,
                                    questions: sec.questions.map((q: Question) =>
                                      q.quesId === question.quesId
                                        ? {
                                            ...q,
                                            options: q.options.map((opt, optIdx) =>
                                              optIdx === idx
                                                ? { ...opt, answer: e.target.value }
                                                : opt
                                            ),
                                          }
                                        : q
                                    ),
                                  };
                                }
                                return sec;
                              });
                              setSections(updatedSections);
                            }}
                            placeholder="Enter answer"
                            ref={idx === question.options.length - 1 ? answerInputRef : null} // Attach ref to the last added Answer field
                          />
                          <input
                            type="text"
                            className="suggestion-input"
                            value={option.suggestion}
                            onChange={(e) => {
                              const updatedSections = sections.map((sec: Section) => {
                                if (sec.sectionId === section.sectionId) {
                                  return {
                                    ...sec,
                                    questions: sec.questions.map((q: Question) =>
                                      q.quesId === question.quesId
                                        ? {
                                            ...q,
                                            options: q.options.map((opt, optIdx) =>
                                              optIdx === idx
                                                ? { ...opt, suggestion: e.target.value }
                                                : opt
                                            ),
                                          }
                                        : q
                                    ),
                                  };
                                }
                                return sec;
                              });
                              setSections(updatedSections);
                            }}
                            placeholder="Enter suggestion"
                          />
                          
                          <input
                            type="number"
                            className="option-input score-input"
                            value={option.score ?? ""}
                            min={0}          // non-negative integers
                            step={1}
                            inputMode="numeric"
                            pattern="[0-9]*"
                            onKeyDown={(e) => {
                              // Block invalid characters for integer-only input
                              const invalidKeys = ["e", "E", "+", "-", "."];
                              if (invalidKeys.includes(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            onChange={(e) => {
                              const raw = e.target.value;
                              let next = 0;

                              if (raw.trim() !== "") {
                                const n = Number(raw);
                                if (!Number.isNaN(n)) {
                                  next = Math.floor(Math.max(0, n)); // keep non-negative integer
                                }
                              }

                              const updatedSections = sections.map((sec: Section) => {
                                if (sec.sectionId === section.sectionId) {
                                  return {
                                    ...sec,
                                    questions: sec.questions.map((q: Question) =>
                                      q.quesId === question.quesId
                                        ? {
                                            ...q,
                                            options: q.options.map((opt, optIdx) =>
                                              optIdx === idx ? { ...opt, score: next } : opt
                                            ),
                                          }
                                        : q
                                    ),
                                  };
                                }
                                return sec;
                              });
                              setSections(updatedSections);
                            }}
                            placeholder="Score"
                            aria-label="Option score (integer only)"
                          />

                          <button
                            onClick={() => {
                              const updatedSections = sections.map((sec: Section) => {
                                if (sec.sectionId === section.sectionId) {
                                  return {
                                    ...sec,
                                    questions: sec.questions.map((q: Question) =>
                                      q.quesId === question.quesId
                                        ? {
                                            ...q,
                                            options: q.options.filter(
                                              (opt, optIdx) => optIdx !== idx
                                            ),
                                          }
                                        : q
                                    ),
                                  };
                                }
                                return sec;
                              });
                              setSections(updatedSections);
                            }}
                          >
                            Remove Option
                          </button>
                        </div>
                      ))}
                      <button
                        onClick={() => {
                          const updatedSections = sections.map((sec: Section) => {
                            if (sec.sectionId === section.sectionId) {
                              return {
                                ...sec,
                                questions: sec.questions.map((q: Question) =>
                                  q.quesId === question.quesId
                                    ? {
                                        ...q,
                                        options: [
                                          ...q.options,
                                          {
                                            optionId: Date.now(),
                                            answer: "",
                                            suggestion: "",
                                            score: null,
                                          },
                                        ],
                                      }
                                    : q
                                ),
                              };
                            }
                            return sec;
                          });
                          setSections(updatedSections);

                          setTimeout(() => {
                            answerInputRef.current?.focus();
                          }, 0);
                        }}
                      >
                        Add Option
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Add Section Button at the bottom only when there is at least one section */}
          {sections.length > 0 && (
            <div className="add-section-container" style={{ marginTop: "20px" }}>
              <button
                className="add-section-btn"
                onClick={() => setIsSectionPopupOpen(true)}
              >
                Add Section +
              </button>
            </div>
          )}
        </div>

        {/* Section Name Popup */}
        {isSectionPopupOpen && (
          <div className="new-popup-container">
            <div className="new-popup">
              <div className="new-popup-content">
                <h4>Enter Section Name</h4>
                <input
                  type="text"
                  className="new-form-control"
                  value={newSectionName}
                  onChange={(e) => setNewSectionName(e.target.value)}
                  placeholder="Enter section name"
                  ref={sectionInputRef}
                />
                <div style={{ marginTop: "10px" }}>
                  <button
                    className="new-create-section-btn"
                    onClick={() => {
                      if (newSectionName.trim() === "") {
                        toast.warning("Section name cannot be empty!");
                        return;
                      }
                      const newSection = {
                        sectionId: sections.length,
                        sectionName: newSectionName,
                        questions: [],
                      };
                      setSections([...sections, newSection]);
                      setNewSectionName("");
                      setIsSectionPopupOpen(false);
                    }}
                  >
                    Create Section
                  </button>
                  <button
                    className="new-cancel-btn"
                    onClick={() => setIsSectionPopupOpen(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Submit button */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            margin: "2rem 0",
          }}
        >
          <button className="submitButton" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
      {isConfirmOpen && newAnswersList.length > 0 && (
        <div className="popup_container">
          <div className="popup">
            <div className="confirm-popup-content">
              <>
                <div>
                  <span>Are you sure you want to save?</span>
                </div>
                <br />
                <span className="addbutton">
                  <button className="add" onClick={confirmPopup("Yes")}>
                    Yes
                  </button>
                </span>
                <span className="savebutton">
                  <button className="save" onClick={confirmPopup("No")}>
                    No
                  </button>
                </span>
              </>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateQuestion;
